import React, { Fragment } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'triider-components';
import { ButtonModal } from 'components/Button';

import styled from 'styled-components';

import { colors } from '../../../styles/stylesheets';

export const Container = styled.div`
  overflow-y: auto;
  padding: 0 40px;
`;
export const ModalHeaderCustom = styled(ModalHeader)`
  padding: 4vh 0;
`;
export const ContentButtons = styled.div`
  padding: 12px 0 40px;
  display: flex;
  justify-content: center;
`;

export const Label = styled.div`
  background: ${colors.greyLighter};
  color: ${colors.greyMedium};
  font-size: 12px;
  line-height: 16px;
  padding: 8px 8px 8px 23px;
  border-radius: 4px;
`;
export const Value = styled.div`
  font-size: 14px;
  line-height: 20px;
  padding: 8px 8px 16px 23px;
`;

function ModalTaskDetails({ task = {}, open, setModalIsOpen }) {
  const taskData = [
    {
      label: 'Solicitado por',
      data: task.user_name,
    }, {
      label: 'Serviço pedido em',
      data: task.created && new Date(task.created).toLocaleDateString(),
    }, {
      label: 'Endereço',
      data: task.address,
    }, {
      label: 'Melhor horário',
      data: task.period_text,
    },
  ];

  if (task.fields) {
    taskData.push(...task.fields.map(valueField => (
      valueField.service_field_option_name ? {
        label: valueField.service_field_name,
        data: valueField.service_field_option_name,
      } : {
        label: valueField.service_field_name,
        data: valueField.value,
      }
    )));
  }

  return (
    <Modal open={open} close={() => setModalIsOpen(false)}>
      <ModalHeaderCustom>
        Detalhes do Pedido
      </ModalHeaderCustom>
      <Container>
        <ModalBody>
          {
            taskData.map(taskDatum => (
              taskDatum && (
                <Fragment key={taskDatum.label}>
                  <Label>
                    {taskDatum.label}
                  </Label>
                  <Value>
                    {taskDatum.data}
                  </Value>
                </Fragment>
              )
            ))
          }
        </ModalBody>
      </Container>
      <ContentButtons>
        <ButtonModal onClick={() => setModalIsOpen(false)}>Entendi</ButtonModal>
      </ContentButtons>
    </Modal>
  );
}

export default ModalTaskDetails;
